import { render } from "./selectPersonal.vue?vue&type=template&id=17fe6aac"
import script from "./selectPersonal.vue?vue&type=script&lang=js"
export * from "./selectPersonal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\humanbrainview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__